// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ecrg7t0 {\n  width: 140px;\n  text-decoration: none;\n  font-size: 12px;\n  color: #333;\n  display: inline-block;\n}\n.ecrg7t0:visited {\n  color: #333;\n}\n.ecrg7t1 {\n  height: 25px;\n  width: 25px;\n  display: inline-block;\n  position: relative;\n  top: 5px;\n}\n.ecrg7t2 {\n  display: flex;\n  text-align: right;\n  padding-right: 10px;\n  justify-content: center;\n}\n.ecrg7t3 {\n  flex: 0.9;\n}", ""]);
// Exports
module.exports = exports;
